import XMLWithEmbeddedJSONParser, {
  type JsonData,
  type ParserResult,
} from './XMLWithEmbeddedJSONParser';

// Stream parser for JSON which understands our simple whiteboard format
// and calls the chunk callback with each complete chunk.
class StreamParser {
  processedMessages = 0;

  responseParser: XMLWithEmbeddedJSONParser;

  constructor(
    private readonly chunkCallback: (type: string, data: JsonData) => void
  ) {
    this.responseParser = new XMLWithEmbeddedJSONParser();
  }

  parse(chunk: string) {
    this.responseParser.append(chunk);

    let action: ParserResult | null;

    while ((action = this.responseParser.parse())) {
      // See if there is something we didn't process yet.
      if (action.tagName === 'message') {
        if (this.processedMessages === 0) {
          this.chunkCallback('message', action.jsonData);
          this.processedMessages++;
        } else {
          console.debug('Ignoring message', action.jsonData);
        }
      } else {
        this.chunkCallback(action.tagName, action.jsonData);
      }
    }
  }
}

export default StreamParser;
